import React from "react";
import styled from "styled-components";
import { Logo } from "../../../assets/images/Logo";
import { Heading } from "../../common/Heading/Heading";

export const AuthLayout = ({ children }) => {
  return (
    <AuthForm>
      <HeaderContainer>
        <LogoContainer>
          <Logo />
        </LogoContainer>
        <Heading text="Grensa.AI" size={2} />
      </HeaderContainer>
      {children}
    </AuthForm>
  );
};

const AuthForm = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 50px auto;
  padding: 40px;
  border: 1px solid #e4def9;
  border-radius: 16px;
  box-shadow: 0px 4px 10px 0px #0000001a;
  background: white;
  height: fit-content;
`;

const LogoContainer = styled.div`
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 2rem;
  margin-bottom: 2rem;
`;
